import React, { useState, useEffect } from "react";
import { useDaumPostcodePopup } from "react-daum-postcode";

import { Button, Col, Input, Row } from "antd";

export type AddressType = {
    address: string;
    addressDetails: string;
};

function AddressMaker({
    value,
    onChangeAddress: onChangeAddress,
}: {
    value?: AddressType;
    onChangeAddress?: (fullAddress: AddressType) => void;
}) {
    const open = useDaumPostcodePopup();

    const [firstAddress, setFirstAddress] = useState("");
    const [secondAddress, setSecondAddress] = useState("");

    const handleComplete = (data: any) => {
        let fullAddress = data.address;
        let extraAddress = "";

        if (data.addressType === "R") {
            if (data.bname !== "") {
                extraAddress += data.bname;
            }
            if (data.buildingName !== "") {
                extraAddress +=
                    extraAddress !== ""
                        ? `, ${data.buildingName}`
                        : data.buildingName;
            }
            fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
        }

        //console.log(fullAddress); // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
        setFirstAddress(fullAddress);
    };

    const handleClick = () => {
        open({ onComplete: handleComplete, popupTitle: "주소검색" });
    };

    useEffect(() => {
        if (value !== undefined) {
            setFirstAddress(value.address);
            setSecondAddress(value.addressDetails);
        }
    }, [value]);

    useEffect(() => {
        if (firstAddress === undefined) return;

        if (firstAddress.length > 0) {
            if (onChangeAddress !== undefined)
                onChangeAddress({
                    address: firstAddress,
                    addressDetails: secondAddress,
                });
        }
    }, [firstAddress, secondAddress]);

    return (
        <Row>
            <Col span={12}>
                <Input
                    value={firstAddress}
                    placeholder='주소'
                    readOnly
                    onClick={handleClick}
                    onChange={(e) => setFirstAddress(e.target.value)}
                />
            </Col>
            <Col span={8}>
                <Input
                    value={secondAddress}
                    placeholder='상세주소'
                    onChange={(e) => setSecondAddress(e.target.value)}
                />
            </Col>
            <Col span={4}>
                <Row justify='end'>
                    <Button onClick={handleClick}>주소검색</Button>
                </Row>
            </Col>
        </Row>
    );
}

export default AddressMaker;
